class MobileNavigation {
	isOpen = false;
	constructor($trigger) {
		this.$trigger = $trigger;
		this.init();
	}

	init = () => {
		this.$trigger.on('click', this.clickHandler);
	};

	clickHandler = e => {
		e.preventDefault();

		if (this.isOpen) {
			this.close();
		} else {
			this.open();
		}
	};

	open = () => {
		window._$html.addClass('nav--open');
		this.isOpen = true;
	};

	close = () => {
		window._$html.removeClass('nav--open');
		this.isOpen = false;
	};
}

export { MobileNavigation };
